import DeleteChecklistModalContent from "features/CenterContent/RoleContent/VehicleChecklist/DeleteChecklistModalContent";
import { FillOut } from "features/CenterContent/RoleContent/VehicleChecklist/schema/responseSchema";
import { FC } from "react";
import {
  DialogRoot,
  DropsDialogContent,
  DropsDialogHeader,
  Text,
} from "shared/components/Spor";
import { useTheme } from "styled-components";

type DeleteChecklistModalProps = {
  onClose: () => void;
  currentFillOut: FillOut;
  handleDelete: () => void;
  refetch: () => void;
};

const DeleteChecklistModal: FC<DeleteChecklistModalProps> = ({
  onClose,
  currentFillOut,
  handleDelete,
  refetch,
}) => {
  const theme = useTheme();
  return (
    <DialogRoot open onOpenChange={onClose} placement="center">
      <DropsDialogContent semantics="alarm">
        <DropsDialogHeader>
          <Text color={theme.colorAlarmTextMain} fontSize="24px">
            Slett kvittering
          </Text>
        </DropsDialogHeader>
        <DeleteChecklistModalContent
          currentFillOut={currentFillOut}
          onClose={onClose}
          handleDelete={handleDelete}
          refetch={refetch}
        />
      </DropsDialogContent>
    </DialogRoot>
  );
};

export default DeleteChecklistModal;
